import * as Yup from 'yup';
import { cleanPhoneNumber } from '@rsos/utils/phoneNumberUtils';
import { isValidPhone } from '@rsos/utils/validators';
import { INVALID_NUMBER } from './constants';

export const initialValues = {
  phoneNumber: '',
  phoneNumberTags: [],
  initialOutboundMessage: '',
};

export const phoneNumberValidator = val => {
  const sanitizedValue = cleanPhoneNumber(val);
  return isValidPhone(sanitizedValue);
};

export const validationSchema = Yup.object().shape({
  phoneNumberTags: Yup.array().test(
    'isValidNumber',
    'Invalid Phone number',
    function (entries) {
      if (entries.length) {
        const { path, createError } = this;
        const result = !entries[0].isValid
          ? createError({ path, message: INVALID_NUMBER })
          : true;
        return result;
      }
      return true;
    },
  ),
  initialOutboundMessage: Yup.string().max(
    280,
    ({ value }) => `Character limit exceeded: ${value.length}/280`,
  ),
});
